import { Controller, useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Autocomplete, FormControl, Stack, TextField, Typography as T } from "@mui/material";
import useDatasetTableFQNs from "datasets/hooks/useDatasetTableFQNs";
import useConfiguratorContext from "datasets/pages/settings/contexts/configurator";

const SourceTable = () => {
  const { domainId } = useParams();
  const { config } = useConfiguratorContext();
  const { formState } = useFormContext();
  const { data: tableFQNs } = useDatasetTableFQNs(false);
  const savedValue = config?.content?.tables.find(({ id }) => id === domainId)?.table;
  const options = tableFQNs?.filter((fqn) => {
    // Filter to only be unused tables or the originally persisted option value
    const unusedTable = !config?.content?.tables.some(({ table }) => table === fqn);
    return unusedTable || savedValue === fqn;
  });

  return (
    <Stack>
      <T variant="h6" fontWeight={550} fontSize={18}>
        Source Table *
      </T>
      <Stack gap={2}>
        <T variant="body2">
          Filters are linked to database tables, choose the table you want to use for this domain’s
          filters.
        </T>
        <FormControl>
          <Controller
            name="table"
            rules={{ required: true }}
            render={({ field }) => (
              <Autocomplete
                {...field}
                size="small"
                disabled={formState.isSubmitting}
                onChange={(_, val) => field.onChange(val)}
                options={options ?? []}
                renderInput={(params) => <TextField {...params} name={field.name} />}
                value={field.value ?? null}
                sx={{ maxWidth: 630, fontSize: 14 }}
                slotProps={{
                  paper: {
                    sx: {
                      fontSize: 14,
                    },
                  },
                }}
              />
            )}
          />
        </FormControl>
      </Stack>
    </Stack>
  );
};

export default SourceTable;
